import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom'
import ReactLoading from "react-loading";
import { GlobalDashboard } from './GlobalDashboard'
import { SectionDashboard } from './SectionDashboard'
import { SubSectionDashboard } from './SubSectionDashboard'
import { OneSubSectionDashboard } from './OneSubSectionDashboard'
import { DetailedDashboard } from './DetailedDashboard'
import { Recommendations } from './Recommendations'
import { GlobalExecSum, SectionExecSum, SubSectionExecSum } from './ExecSums'
import { QuestionCopy } from './QuestionCopy';
import Logo from './banner.jpg';
import * as Session from './session'
import * as Questions from './questions'
import ReactGA from 'react-ga'

class Report extends Component {

    constructor(props) {
        super(props)
        ReactGA.pageview(window.location.pathname + window.location.search);
        this.state = {
        ...Session.currentSession,
        __isLoading: false,
        __isSaving: false,
        __shouldRedirectToRegister: false,
        __shouldRedirectToStart: false
        }
        if (!Session.isInitiated()) {
            this.state.__isLoading = true
            const { userEmail } = props.match.params
            Session.getSessionForUserEmail(userEmail).then(response => {
                this.setState({
                    __isLoading: false,
                    ...Session.currentSession,
                    __shouldRedirectToRegister: !Session.isInitiated(),
                    __shouldRedirectToStart: Session.isInitiated() && !Session.isFinished()
                })
            })
        }
    }

    render() {
        const { userEmail } = this.props.match.params
        if (this.state.__isLoading) {
            return <LoadingPanel />
        } if (this.state.__shouldRedirectToRegister) {
            return <Redirect to={`/user/${userEmail}/notfound`} />
        } else if (!this.state.isFinished) {
            return <Redirect to={Session.startSubSectionUrl(userEmail)} />
        } else if (this.state.responses) {
            return (
                <div>
                    <ReportPage>
                        <div className="text-center">
                            <img src={Logo} height="100" style={{borderRadius: '0.25em'}}/>
                            <br/><br/>
                            <h1 >Relatório de Auto-Diagnóstico</h1>
                            <br/><br/>
                            <CasePanel session={this.state}/>
                        </div>
                        <VerticalSpacer/>
                        <hr/>
                        <VerticalSpacer/>
                        <h5>Resultado Global</h5>
                        <GlobalDashboard tree={this.state.responses}/>
                        <GlobalExecSum tree={this.state.responses}/> 
                        <VerticalSpacer em="2"/> 
                    </ReportPage>
                    <ReportPage>
                        <VerticalSpacer />
                        <hr/>
                        <VerticalSpacer em="2"/>
                        <h3>Resultados por Secção</h3>
                        <Panel
                            content={<SectionDashboard 
                                tree={this.state.responses}
                                />}
                            />
                        <SmallVerticalSpacer />
                        <SectionExecSum tree={this.state.responses}/>
                    </ReportPage>
                    <ReportPage>
                        <VerticalSpacer />
                        <hr/>
                        <VerticalSpacer em="2"/>
                        <h3>Resultados por SubSecção</h3>
                        <Panel 
                            content={<SubSectionDashboard 
                                tree={this.state.responses}
                                />}
                            />
                        <SmallVerticalSpacer />
                        <SubSectionExecSum tree={this.state.responses}/>
                    </ReportPage>
                    <ReportPage>
                        <div className="d-print-none">
                            <VerticalSpacer />
                            <hr/>
                            <VerticalSpacer />
                            <h3 className="">Recomendações</h3>
                        </div>
                        <SubSectionDashboardList 
                            tree={this.state.responses}
                            />
                    </ReportPage>
                    <ReportPage>
                        <VerticalSpacer />
                        <hr/>
                        <VerticalSpacer />
                        <h3>Respostas</h3>
                        <VerticalSpacer em="2"/>
                        <QuestionCopy 
                            tree={this.state.responses}
                            />
                    </ReportPage>
                </div>
            )
        } else {
            return null
        }
    }
}

export default withRouter(Report)

const ReportPage = (props) => (
    <div {...props} style={{pageBreakAfter: 'always', ...props.style}}>
        {props.children}
    </div>
)

const SubSectionDashboardList = (props) => (
    props.tree.sections.map( (section, sectionOffset) => (
        <div key={sectionOffset}>
            <div className="d-print-none">
                <VerticalSpacer />
                <hr/>
                <VerticalSpacer />
                <h5>{section.title}</h5>
                <VerticalSpacer />
            </div>
            {section.subSections.map( (subSection, subSectionOffset) => (
                <ReportPage key={subSectionOffset}>
                    <div className="d-none d-print-block">
                        <VerticalSpacer />
                        <hr/>
                        <VerticalSpacer />
                        <h3>Recomendações</h3>
                        <VerticalSpacer />
                        <h5 className="d-none d-print-block">{section.title}</h5>
                    </div> 
                    <Panel 
                        key={subSectionOffset}
                        header={subSection.title}
                        content={<OneSubSectionDashboard 
                            subSection={subSection}
                            />}
                        />
                    <SmallVerticalSpacer />
                    <Recommendations
                        subSection={subSection}
                        />
                    <VerticalSpacer />
                </ReportPage>
            ))}
        </div>
    ))
)


const Panel = (props) => (
    <div className="card">
        {   props.header && 
                <div className="card-header">{props.header}</div>
        }
        <div className="card-body" style={ { padding: '0'} }>
            {props.content}
        </div>
    </div>
)

const LoadingPanel = (props) => (
    <div className="text-center">
        <br/>
        <span>A carregar ...</span>
        <br/>
        <br/>
        <ReactLoading type="spin" color="blue" className="mx-auto"/>
    </div>
  )

const SmallVerticalSpacer = (props) => <VerticalSpacer em="2"/>

const VerticalSpacer = (props) => <div style={ { height: `${props.em || 3}em`} }></div>


const CasePanel = (props) => (
    <div className="card mx-auto" style={{width: '30rem'}}>
        <div className="card-header">
            Identificação do Relatório
        </div>
        <table className="table">
            <tbody>
                <tr>
                    <td>Empresa</td><td>{props.session.companyId}</td>
                </tr>
                <tr>
                    <td>Email</td><td>{props.session.contactEmail}</td>
                </tr>
                <tr>
                    <td>Sector</td><td>{props.session.sectorId}</td>
                </tr>
            </tbody>
        </table>
    </div>
)


// WEBPACK FOOTER //
// ./src/Report.jsx